if (!customElements.get('product-price')) {
  customElements.define(
    'product-price',
    class ProductPrice extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
      }

      initializeProductSwapUtility() {
        const productId = this.getAttribute('data-product-id');
        const productData = window.modalInquiredByPrice[`product_${productId}`];
        const available = window.modalByAvailable.isAvailable;

        if (productData?.hidePrice || !available) {
          this.hidePrice();
        }
      }

      hidePrice = () => {
        this.querySelector('.price').classList.add('hidden');
      };
    }
  );
}
